import { createContext, useContext, useState } from "react";
import { ContextureButtonStyle, ContexturePanelStyle } from "../../assets/styles";
import { ContextureButton, ContextureCategory, ContexturePanel } from "../../components/Contexture/Contexture";
import Flaticon from "../../components/Flaticon/Flaticon";


const CONTEXT_MENU_OFFSET = 5;

const ContextMenu = () => {
  const { contextMenu, showContextMenu, setShowContextMenu, contextMenuPosition, contextMenuData } = useContextMenu();
  const [ loadingItemId, setLoadingItemId ] = useState(null);

  const handleItemClick = (id, onClick, data, e) => {
    if (!onClick) return;
    const result = onClick(data, e);
    if (result && typeof result.then === 'function') {
      setLoadingItemId(id);
      result.finally(() => {
        setLoadingItemId(null);
        setShowContextMenu(false);
      });
    } else {
      setShowContextMenu(false);
    }
  };

  return (
    <ContexturePanel
      id="context-menu"
      className={ ContexturePanelStyle }
      show={ showContextMenu }
      position={ { x: contextMenuPosition.x + CONTEXT_MENU_OFFSET, y: contextMenuPosition.y + CONTEXT_MENU_OFFSET } }
      onClose={ () => !loadingItemId && setShowContextMenu(false) }
    >
      { contextMenu?.map((context) => {
        if (context instanceof Array) {
          return context?.map(({ id, name, icon, onClick }, k) => {
            return (
              <ContextureButton
                className={ ContextureButtonStyle }
                key={ id }
                disabled={ loadingItemId !== null && loadingItemId !== id }
                loading={ loadingItemId === id }
                onClick={ (e) => handleItemClick(id, onClick, contextMenuData, e) }
              >
                <Flaticon name={ icon.name } type={ icon.type } size={ 16 } className="w-2" />
                <span>{ name }</span>
              </ContextureButton>
            );
          });
        } else if (context instanceof Object) {
          return (
            <ContextureCategory key={ context.id } label={ context.name }>
              { context.items.map(({ id, name, icon, onClick }, k) => (
                <ContextureButton
                  className={ ContextureButtonStyle }
                  key={ id }
                  disabled={ loadingItemId !== null && loadingItemId !== id }
                  loading={ loadingItemId === id }
                  onClick={ (e) => handleItemClick(id, onClick, contextMenuData, e) }
                >
                  <Flaticon name={ icon.name } type={ icon.type } size={ 16 } className="w-2" />
                  <span>{ name }</span>
                </ContextureButton>
              )) }
            </ContextureCategory>
          );
        } else {
          return null;
        }
      }) }
    </ContexturePanel>
  );
};

const ContextMenuContext = createContext();

const ContextMenuProvider = ({ children }) => {
  const [ contextMenu, setContextMenu ] = useState(undefined);
  const [ showContextMenu, setShowContextMenu ] = useState(false);
  const [ contextMenuPosition, setContextMenuPosition ] = useState({ x: 0, y: 0 });
  const [ contextMenuData, setContextMenuData ] = useState(undefined);

  const value = {
    setContextMenu: ({ context, position, data }) => {
      setContextMenu(context);
      setContextMenuPosition(position);
      setContextMenuData(data);
      setShowContextMenu(true);
    },
    contextMenu,
    contextMenuData,
    showContextMenu,
    setShowContextMenu,
    contextMenuPosition,
    setContextMenuPosition
  };

  return (
    <ContextMenuContext.Provider value={ value }>
      { children }
    </ContextMenuContext.Provider>
  );
};

const useContextMenu = () => useContext(ContextMenuContext);

export default ContextMenu;
export { ContextMenuProvider, useContextMenu };

